import React, {useState} from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";
import Ecommerce from "../../images/services/cto/Ecommerce.svg";
import RealEstate from "../../images/services/cto/RealEstate.svg";
import Gaming from "../../images/services/cto/Gaming.svg";
import Healthcare from "../../images/services/cto/Healthcare.svg";
import Lifestyle from "../../images/services/cto/lifestyle.svg";
import {LazyLoadImage} from "react-lazy-load-image-component";


function Industries(props) {
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    const getActiveClass = (index, className) =>
        toggleState === index ? className : "";

    return (
        <div className="seriveces_industries p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={7} xl={7} xxl={7}>
                        <div className="example" data-text="We Serve">
                            <h2>Industries We Serve</h2>
                        </div>
                        <p className="strong">Technological change is one of the major global forces reshaping the
                            business ecosystem. While TekRevol understands this fact, it also appreciates that any
                            industrial sector is currently influenced by tech. To cater to the changing needs of its
                            client partners, TekRevol provides technology consulting to businesses in the following
                            industries.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="deskstop_version">
                        <div className="process_icons">
                            <ul>
                                <li className={`tabs ${getActiveClass(1, "active-tabs")}`}
                                    onClick={() => toggleTab(1)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Healthcare}
                                            effect="blur" alt="Healthcare" className="img-fluid"
                                        />
                                    </div>
                                    Healthcare
                                </li>
                                <li className={`tabs ${getActiveClass(2, "active-tabs")}`}
                                    onClick={() => toggleTab(2)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={RealEstate}
                                            effect="blur" alt="Real Estate" className="img-fluid"
                                        />
                                    </div>
                                    Real Estate
                                </li>

                                <li className={`tabs ${getActiveClass(3, "active-tabs")}`}
                                    onClick={() => toggleTab(3)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Gaming}
                                            effect="blur" alt="Gaming" className="img-fluid"
                                        />
                                    </div>
                                    Gaming
                                </li>
                                <li className={`tabs ${getActiveClass(4, "active-tabs")}`}
                                    onClick={() => toggleTab(4)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Ecommerce}
                                            effect="blur" alt="Ecommerce" className="img-fluid"
                                        />
                                    </div>
                                    Ecommerce
                                </li>
                                <li className={`tabs ${getActiveClass(5, "active-tabs")}`}
                                    onClick={() => toggleTab(5)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Lifestyle}
                                            effect="blur" alt="Lifestyle" className="img-fluid"
                                        />
                                    </div>
                                    Lifestyle
                                </li>

                            </ul>

                            <div className={toggleState === 1 ? 'content d-block' : "content d-none"}>
                                <p>Technical disruption has its most prominent transformative use cases in the
                                    healthcare sector, equally impacting the product, service, and solutions side.
                                    TekRevol’s CTO as a Service and consultancy can build solutions to automate the
                                    product manufacturing and supply chain for businesses with a product facility. Our
                                    tech executives can help improve patient outcomes and accelerate drug discovery and
                                    capacity planning for services, research, and solutions.</p>
                            </div>
                            <div className={toggleState === 2 ? 'content d-block' : "content d-none"}>
                                <p>TekRevol’s tech leadership has helped build digital products and solutions onsite to
                                    automate documentation, business development, and customer engagement, accelerate
                                    lead generation, and improve conversion for realtors, property entrepreneurs, and
                                    real estate marketers.</p>
                            </div>
                            <div className={toggleState === 3 ? 'content d-block' : "content d-none"}>
                                <p>With our tech expertise, you can build next-gen gaming experiences for your target
                                    audience by reinventing the booking and monetization processes and transferring
                                    rewards in play-to-earn games.</p>
                            </div>
                            <div className={toggleState === 4 ? 'content d-block' : "content d-none"}>
                                <p>Technology consulting in the ecommerce industry increases direct sales and turnover
                                    ratio. TekRevol can help you build fully-automated ecommerce solutions that allow
                                    uninterrupted buyer journey, seamless payment and navigation, and order
                                    management.</p>
                            </div>
                            <div className={toggleState === 5 ? 'content d-block' : "content d-none"}>
                                <p>TekRevol has built smart systems to automate the lifestyle sector. Internet of
                                    Things, blended with voice and image recognition systems, helps create a safe,
                                    secure home and office environments for diverse stakeholders. And TekRevol can help
                                    you and your internal development teams utilize the emerging tech and put them to
                                    their best use.</p>
                            </div>

                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="mobile_version">
                        <div className="tekrevol_mobile_accordion_side">
                            <Accordion
                                defaultActiveKey="1">

                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Healthcare}
                                            effect="blur" alt="Healthcare" className="img-fluid"
                                        />
                                        Healthcare
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>Technical disruption has its most prominent transformative use cases in the
                                            healthcare sector, equally impacting the product, service, and solutions
                                            side. TekRevol’s CTO as a Service and consultancy can build solutions to
                                            automate the product manufacturing and supply chain for businesses with a
                                            product facility. Our tech executives can help improve patient outcomes and
                                            accelerate drug discovery and capacity planning for services, research, and
                                            solutions.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={RealEstate}
                                            effect="blur" alt="Real Estate" className="img-fluid"
                                        />
                                        Real Estate
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>TekRevol’s tech leadership has helped build digital products and solutions
                                            onsite to automate documentation, business development, and customer
                                            engagement, accelerate lead generation, and improve conversion for realtors,
                                            property entrepreneurs, and real estate marketers.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Gaming}
                                            effect="blur" alt="Gaming" className="img-fluid"
                                        />
                                        Gaming
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>With our tech expertise, you can build next-gen gaming experiences for your
                                            target audience by reinventing the booking and monetization processes and
                                            transferring rewards in play-to-earn games.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Ecommerce}
                                            effect="blur" alt="Ecommerce" className="img-fluid"
                                        />
                                        Ecommerce
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>Technology consulting in the ecommerce industry increases direct sales and
                                            turnover ratio. TekRevol can help you build fully-automated ecommerce
                                            solutions that allow uninterrupted buyer journey, seamless payment and
                                            navigation, and order management.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Lifestyle}
                                            effect="blur" alt="Lifestyle" className="img-fluid"
                                        />
                                        Lifestyle
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>TekRevol has built smart systems to automate the lifestyle sector. Internet
                                            of Things, blended with voice and image recognition systems, helps create a
                                            safe, secure home and office environments for diverse stakeholders. And
                                            TekRevol can help you and your internal development teams utilize the
                                            emerging tech and put them to their best use.</p>
                                    </Accordion.Body>
                                </Accordion.Item>

                            </Accordion>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Industries;